import dynamic from "next/dynamic";
import { SelfCheckoutProps } from "design-system/template/checkout/checkout.types";

const SelfCheckout = dynamic<SelfCheckoutProps>(
  () =>
    import("design-system/template/checkout/checkout").then(
      (mod) => mod.SelfCheckout
    ),
  { ssr: false }
);

const SelfCheckoutPage: React.FC = () => {
  return <SelfCheckout />;
};

export default SelfCheckoutPage;
